<pageheader [entity]="headerEntity"></pageheader>
<div *ngIf="listView" class="top-btns">
    <div class="table-outer">
        <grid [entities]="Modules" [actionExclude]="['feedback','column']"  [checkboxCol]="true" [entityColumns]="ModuleColumns" [selectionField]="'Module_Id'"
            [addEntityIcon]="'bi bi-plus-square'" [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download '" (downloadEntities)="onExcelExport()"
            (addEntity)="addModule($event)" (editEntity)="editModule($event)" (refreshEntities)="refreshModule($event)"
            (deleteEntity)="deleteModule($event)" (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip"></grid>
    </div>
</div>
<div *ngIf="!listView">
    <div class="report top-btns">
        <div class="form-caption-nav">
              {{ formCaption }}
        </div>
        <nav class="navbar-expand-md navbar-white navbar-form bg-light  mt-2">
            <ul class="navbar-nav justify-content-end">
                
                <li class="nav-item">
                    <a class="nav-link" (click)="clearModule()"><i class="bi bi-slash-circle"></i>Clear</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="revertChanges()"><i class="bi bi-arrow-clockwise"></i>Revert
                        Changes</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="gotoBack()"><i class="bi bi-arrow-left-circle"></i>Go Back</a>
                </li>
            </ul>
        </nav>
        <div class="form-body">
            <div class="row">
                <div class="col-md-4">
                    <div class="mb-3">
                        <textbox [caption]="'Module Name'" [formData]="entity" [maxlength]="100" [mandatory]="true"
                            [fieldName]="'Module_Name'" [(ngModel)]="entity.Module_Name" ngDefaultControl></textbox>
                    </div>
                </div>
                <div class="mt-3">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'"
                    [disabled]="saveDisabled" [type]="'button'"></btn>
                </div>
            </div>
        </div>
    </div>
</div>
<kendo-excelexport [data]="Modules.data" [collapsible]="true" fileName="Modules.xlsx" #excelexport>
    <kendo-excelexport-column field="Module_Name" title="Name" [width]="200">
    </kendo-excelexport-column>
   
</kendo-excelexport>